import { render, staticRenderFns } from "./StandorteView.vue?vue&type=template&id=fe5ef0aa"
import script from "./StandorteView.vue?vue&type=script&scoped=true&lang=js"
export * from "./StandorteView.vue?vue&type=script&scoped=true&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports